function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2V8H20",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 13H8",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 17H8",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10 9H9H8",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 7,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6479 18.9337C17.3694 19.2121 16.4971 19.2113 16.2193 18.9337C15.9404 18.6547 15.4881 18.6547 15.2092 18.9337C14.9302 19.2126 14.9303 19.6649 15.2092 19.9438C15.5088 20.2434 15.9381 20.447 16.4285 20.5298V21.2857C16.4285 21.6802 16.7483 22 17.1428 22C17.5373 22 17.8571 21.6802 17.8571 21.2857V20.4243C19.7318 19.7871 19.6781 17.277 17.9646 16.5673L16.8678 16.1129C16.297 15.8766 16.1944 14.8572 17.3521 14.8572C17.701 14.8572 17.9622 14.9623 18.0664 15.0664C18.3453 15.3454 18.7976 15.3454 19.0765 15.0664C19.3555 14.7875 19.3554 14.3352 19.0765 14.0563C18.7769 13.7567 18.3477 13.5531 17.8572 13.4703V12.7143C17.8572 12.3198 17.5374 12 17.1429 12C16.7484 12 16.4286 12.3198 16.4286 12.7143V13.5757C14.5702 14.2074 14.593 16.7169 16.3211 17.4327L17.4179 17.8871C17.8293 18.0575 17.9799 18.6007 17.6479 18.9337Z",
  fill: "#0067E2"
});

var SvgIcNavQuote = function SvgIcNavQuote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcNavQuote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-nav-quote.c284dcb6.svg";
export { ForwardRef as ReactComponent };